import './index.less'
import {InitCollectionTabs} from "./../snippets/collection-tabs.js"
import {InitPromotionaPrice} from "./../snippets/promotiona-price.js"

window.$(document).ready(function(){
    InitCollectionTabs()
    InitPromotionaPrice()

    // 数据埋码
    function GAEvent(params) {
        window.dataLayer.push({ "event_parameters": null });
        window.dataLayer.push({
            "event":"ga4Event",
            "event_name":"product_collection_user_clicks",
            "event_parameters":{
                "current_page": window.location.href, // current page url,
                "module": "Mobile_More",
                ...params
            }
        })
    }

    $(".product-grid__list .view-all_mobile").on('click', function() {
        const close = $(this).hasClass('active')
        const t_ = $(this).attr("data-collection")
        const currentCollection = ".product-grid__list[data-collection='"+ t_ +"']"

        if(close) {
            $(this).removeClass('active')
            $(currentCollection).removeClass('active')
        } else {
            $(this).addClass('active')
            $(currentCollection).addClass('active')

            GAEvent({
                title: $(this).attr('data-title'),
                button_name: $(this).attr('data-see-more'),
                status: window?.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
            })
        }
    })


})